import MixPanel from 'mixpanel-browser';

import envConfig from '../config/environment';
import { RolesName } from '../config/constants';
import { v4 as uuidv4 } from 'uuid';

const envCheck = envConfig.currentInstance;

const actions = {
	identify: (id: string) => {
		if (envCheck) MixPanel.identify(id);
	},
	alias: (id: string) => {
		if (envCheck) {
			const anonymousUserId = MixPanel.get_distinct_id();
			MixPanel.alias(id, anonymousUserId);
		}
	},
	track: (name: string, props: any = {}) => {
		if (envCheck && MixPanel.track) MixPanel.track(name, { ...props, '$insert_id': uuidv4() });
	},
	people: {
		set: (name: string, props: any) => {
			if (envCheck) MixPanel.people.set(name, props);
		},
		resetUser: () => {
			if (envCheck) MixPanel.reset();
		},
		incrementViewCount: (prop: any, by: any) => {
			if (envCheck) MixPanel.people.increment(prop, by, undefined);
		},
	},
	super: {
		set: (props: any) => {
			if (envCheck) MixPanel.register(props);
		},
	},
};

export const saveMixpanelUserInfo = (userInfo: any) => {
	MixPanelService.alias(userInfo.uid);
	MixPanelService.people.set('$name', userInfo.name);
	MixPanelService.people.set('$email', userInfo.email);
	MixPanelService.people.set('$phone', userInfo.phone);
	MixPanelService.people.set('is_test_user', userInfo.isTestUser || false);
	MixPanelService.people.set('uid', userInfo.uid);
	MixPanelService.people.set('user_country', userInfo.countryCode);
	MixPanelService.super.set({ user_type: RolesName[userInfo.role] });
	MixPanelService.super.set({ source: 'WeCare Diabetes Provider' });
	MixPanelService.people.set('login_types', 'email');
	MixPanelService.people.set('user_type', RolesName[userInfo.role]);
	MixPanelService.people.set('$distinct_id', userInfo.uid);
	MixPanelService.people.set('$referring_domain', envConfig.baseURL());
	MixPanelService.identify(userInfo.uid);
}

export const initializeMixPanel = async () => {
    MixPanel.init(envConfig.mixPanelToken(), {'loaded':function() {
        MixPanel.register({ app_flavor: envCheck, referring_domain: envConfig.baseURL() });
    }});
    
 
};

export const MixPanelService = actions;
